module.exports = __webpack_public_path__ + "img/nodata_follow.85041d46.png";